import { paymentFailure } from './m9Money';
export async function paymentContext(client, accountId, tripId = null) {
    const { data, error } = await client.rpc('m9_payment_context', { p_account: accountId || null, p_trip: tripId });
    if (error || !data) throw new Error('We couldn’t open Payments. Please try again.');
    return data;
}
export async function requestPayment(client, fields) {
    const route = await client.rpc('m9_payment_route', { p_fields: fields });
    if (route.error || !route.data) throw new Error(paymentFailure());
    const { data: gate, error: gateError } = await client.rpc('module_door_open', { p_org: route.data.orgId, p_module: route.data.module, p_door: route.data.door, p_recipient: route.data.recipient || {} });
    if (gateError || gate?.open !== true || gate?.decision !== 'allow') throw new Error('Payments aren’t available for this account yet. Please contact your account team.');
    let result;
    try { result = await client.functions.invoke('stripe-setup-intent', { body: { ...fields, action: `m9_${fields.action}` } }); } catch { throw new Error(paymentFailure()); }
    if (result.error || result.data?.error || !result.data) throw new Error(paymentFailure());
    if (result.data.caught) throw new Error('Payments aren’t available for this account yet. Please contact your account team.');
    return result.data;
}
